
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './layouts/full/breadcrumb/breadcrumb.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { mailService,mailGlobalVariable } from './apps/mailbox/mail.service';
import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './shared/spinner.component';
import { UIPagesComponent } from './ui-pages/ui-pages.component';
import { LoginComponent } from './ui-pages/login/login.component';
// import { NgApexchartsModule } from 'ng-apexcharts';
// import { BreadcrumbComponent } from './UI-Pages/layouts/breadcrumb/breadcrumb.component';
// import { HeaderComponent } from './UI-Pages/layouts/header/header.component';
// import { SidebarComponent } from './UI-Pages/layouts/sidebar/sidebar.component';

import { LoginService } from './_services/login.service';
import { User } from './_models/user';
import { FieldTrackComponent } from './field-track/field-track.component';
import { FiedappService } from './_services/fiedapp.service';
import { DatePipe } from '@angular/common';
import { DailyattendanceDialogContent,DailyAttendanceComponent } from './attendance/daily-attendance/daily-attendance.component';
import { EmployeeDialogContent, MonthlyAttendanceComponent } from './attendance/monthly-attendance/monthly-attendance.component';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { HashLocationStrategy,LocationStrategy } from '@angular/common';
import { DeviceResetComponent } from './devicereset/device-reset/device-reset.component';
import { EmployeeDetailComponent } from './employeeMaster/employee-detail/employee-detail.component';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    wheelSpeed: 2,
    wheelPropagation: true
};

@NgModule({
    declarations: [
        AppComponent,
        FullComponent,
        AppHeaderComponent,
        SpinnerComponent,
        AppBlankComponent,
        AppSidebarComponent,
        AppBreadcrumbComponent,
        UIPagesComponent,
        LoginComponent,
        FieldTrackComponent,
        DailyAttendanceComponent,
        MonthlyAttendanceComponent,
        EmployeeDialogContent,
        DailyattendanceDialogContent,
        DeviceResetComponent,
        EmployeeDetailComponent
        // BreadcrumbComponent,
        // HeaderComponent,
        // SidebarComponent,
      
     
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        DemoMaterialModule, 
        FormsModule,
        FlexLayoutModule,
        HttpClientModule,
        PerfectScrollbarModule,
        SharedModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        NgMultiSelectDropDownModule.forRoot(),
        //NgApexchartsModule,
        RouterModule.forRoot(AppRoutes)
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG, 
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
           
        },
        { 
            provide: MAT_DATE_LOCALE, useValue: 'en-GB'
        },{
            provide: LocationStrategy, useClass: HashLocationStrategy
        }, mailService,mailGlobalVariable,LoginService,FiedappService,User,DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
